import { render, staticRenderFns } from "./UnusableFeatureSection.vue?vue&type=template&id=76f6fb07&scoped=true"
import script from "./UnusableFeatureSection.vue?vue&type=script&lang=ts"
export * from "./UnusableFeatureSection.vue?vue&type=script&lang=ts"
import style0 from "./UnusableFeatureSection.vue?vue&type=style&index=0&id=76f6fb07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f6fb07",
  null
  
)

export default component.exports